import classes from "./Footer.Module.css";

const Footer = () => {
  return (
    <div className={classes.footer}>
      Jesswin Chetnani | All Rights Reserved-2021
    </div>
  );
};

export default Footer;
